import React from 'react';
import { Stack, Input, Text, Textarea } from '@moda/om';

import './SameDayDeliveryFields.scss';

interface Props {
  phone: string;
  onPhoneChange: (value: string) => void;
  phoneError?: string;
  deliveryNotes: string;
  onDeliveryNotesChange: (value: string) => void;
}

export const SameDayDeliveryFields: React.FC<Props> = ({
  phone,
  onPhoneChange,
  phoneError,
  deliveryNotes,
  onDeliveryNotesChange
}) => (
  <Stack className="SameDayDeliveryFields" space={4}>
    <Input
      label="Phone Number for Delivery*"
      type="tel"
      name="sameDayPhone"
      value={phone}
      onChange={onPhoneChange}
      error={phoneError}
    />

    <Stack space={1}>
      <Text>Same-Day Delivery Instructions (Optional)</Text>
      <Textarea
        name="sameDayDeliveryNotes"
        value={deliveryNotes}
        onChange={onDeliveryNotesChange}
        rows={3}
        maxLength={150}
      />
    </Stack>
  </Stack>
);
